module.exports = __webpack_public_path__ + "static/media/input-icon-calendar~guvcZhGY.e7759907.svg";